import {inject} from "vue";

class Provider {
    app;
    constructor(app) {
        this.app = app;
    }

    provide(name, value) {
        this.app.provide(name, value);
    }
}

export default {
    install(app) {
        app.provide('provider', new Provider(app));
    }
}

export function useProvider() {
    return inject('provider');
}